// ** MUI Imports
import {
  Grid,
  Typography,
  Box,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DataGridPro } from '@mui/x-data-grid-pro';

// ** Icon Imports
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

// ** Third-Party Imports
import { toast, ToastContainer } from "react-toastify";

// ** Dialog Imports
import AddIndustryDialog from "./AddIndustry";

// ** Logic Imports
import { useSettingPermission } from "../permissions/SettingPermissions";
import { useIndustryLogic } from "../logic/industry-logic";

const IndustryTab = () => {
  //#region Permissions
  const { SettingPermissionProps } = useSettingPermission();
  const {
    hasIndustrySavePermission,
    hasIndustryGetPermission,
    hasIndustryDeletePermission,
  } = SettingPermissionProps;
  //#endregion Permissions

  //#region Props Destructuring
  const { IndustryProps } = useIndustryLogic(toast);
  const {
    handleOpenIndustryDlg,
    filteredRows,
    columns,
    paginationModel,
    setPaginationModel,
    openIndustryDlg,
    handleCloseIndustryDlg,
    rows,
    searchQuery,
    handleSearchChange,
  } = IndustryProps;
  //#endregion Props Destructuring

  return (
    <>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", lg: "row" }, 
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", lg: "center" }, 
              gap: { xs: 2, lg: 0 } 
            }}
          >
            <Box>
              <Typography variant="h3">Service Industries</Typography>
              <Typography color="secondary">
                Manage your desired Service Industries in the system.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
              <TextField
                placeholder="Search industries..."
                value={searchQuery}
                onChange={handleSearchChange}
                size="small"
                sx={{
                  width: { xs: "100%", sm: 300 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="main"
                startIcon={<AddIcon />}
                disabled={!hasIndustrySavePermission}
                {...(hasIndustrySavePermission && {
                    onClick: handleOpenIndustryDlg
                })}
                sx={{
                  whiteSpace: 'nowrap'
                }}
              >
                Create Industry
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <DataGridPro
            // pagination
            rows={filteredRows || rows || []}
            rowHeight={62}
            columns={columns}
            // pageSizeOptions={[
            //   10,
            //   50,
            //   { value: (filteredRows || rows || []).length, label: "Show All" },
            // ]}
            disableRowSelectionOnClick
            // paginationModel={paginationModel}
            // onPaginationModelChange={setPaginationModel}
            sx={{
                minHeight: 250,
                maxHeight: 500,
              "& .MuiDataGrid-columnHeaderTitle": {
                textTransform: "none",
              },
            }}
            slots={{
              footer: () => null
            }}
          />
        </Grid>
      </Grid>

      {/*<ToastContainer />*/}

      <AddIndustryDialog
        open={openIndustryDlg}
        handleClose={handleCloseIndustryDlg}
        IndustryProps={IndustryProps}
      />
    </>
  );
};

export default IndustryTab;